<template>
	<div class="maxMaxth home-scrollbar menPensmeConems me3Dian6"  :style="{
		'background-image': `url(${config.background_image})`,
	}" >
		<advertisementHome v-if="popList.length" @CancelDisplay="CancelDisplay"
			:popList="popList" :isShow="isCancelDisplay"></advertisementHome>
		<sidebars :sidebarsList="sidebarsList"> </sidebars>
		<SanDianLiu></SanDianLiu>
		<div class="conterTeng-scrollbar" 
		ref="homeScrollbar"
		@scroll="handleScroll"
		:style="{
			height:`calc(100vh - ${$store.state.xiazApp?.9+.7:.9}rem)`
		}">
			<Swipe :swipeList="banner"></Swipe>
			<div class="notice-barCome">
				<div class="notice-bar" >
					<div style="position: relative;width: .32rem;height: .32rem;color: var(--theme-text-color);margin-right: .2rem;">
						<svg-icon class="svg-icon_pmd mt2" style="font-size: .32rem;" icon-class="icon_dt_2pmd--svgSprite:all" />
					</div>
					<van-notice-bar class="marquee" style="height: 20px;" :left-icon="tongzhi" :scrollable="true">
						<div style="display: flex;align-items: center;">
							<div v-for="(item,index) in marquee" @click="openUrl('notice',{active:3,marqueeIndex:index}) " v-html="item"></div>
						</div>
					</van-notice-bar>
					<i
						:style="`margin-left:5px;display: inline-block; position: relative; width: 0.5rem; height: 0.4375rem; background-image: url(${_coloImg}); background-position: -5.3375rem -4.275rem; background-size: 9.075rem 8.85625rem;`"></i>
				</div>
			</div>
			<div class="notice-barCome warp-wYU5E" style="margin-top: .16rem;" v-if="!vuex_token_head">
				<div class="warp-notlogin-azGf5">
					<div class=""  @click="$store.commit('isRecord'),$store.commit('publicFun',['isRecordType',1])">
						<span>LOGIN</span>
					</div>
					<div class="" @click="$store.commit('isRecord'),$store.commit('publicFun',['isRecordType',0])">
						<span>REGISTRO</span>
					</div>
				</div>
			</div>
			<!-- --theme-mine-icon-color -->
			<div class="" v-else>
				<div class="warp-wYU5E notice-barCome">
					<div class="warp-wYU5EComes">
						<div>
							<div style="display: flex;align-items: center;">
								<span class="warp-card-user-login-wrap-vip-BttMM">VIP {{userInfo.vip_info.level}}</span>
								<div class="me-infoname" @click="copyContent(userInfo.user_name)" >
									<i>{{userInfo.user_name}} </i>
									<svg-icon style="width: 0.28rem; height: 0.28rem;margin-left: .02rem;" className="imageWrap" icon-class="style_1_icon_copy--svgSprite:all" />
								</div>
							</div>
							<div class="countTextBox" @click="animate">
								<i class="yj5rHjAv0U7RlHMzWr7F img skeleton-box" :style="{
									backgroundImage:`url(${_coloImg})`
								}" style="display: inline-block; position: relative; width: 0.3rem; height: 0.3rem;background-position: -7.15714rem -2.79643rem; background-size: 7.77857rem 7.59107rem;"></i>
								<span class="notranslate">{{userBalance}}</span>
								<svg-icon class="xuanzhuan" icon-class="comm_icon_sx--svgSprite:all" />
							</div>
						</div>
						<!-- #icon-sprite_ -->
						<div class="SaqueDepósito">
							<div @click="$store.commit('isDeposit',true)">
								<svg-icon class="xuanzhuan" icon-class="icon-mes" classNameQita />
								<p>{{ $t('mine._Depósito') }}</p>
							</div>
							<div @click="openUrl(userInfo.set_withdraw_password?'withdraw':'security')">
								<svg-icon class="xuanzhuan" icon-class="icon-nem-sems-a" classNameQita />
								<p>{{ $t('mine._Saque') }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="crcd82r1PVsQivOcCftk" v-if="!vuex_token_head">
				<van-button @click="$store.commit('isRecord'),$store.commit('publicFun',['isRecordType',1])"
					type="primary" size="mini">{{$t('Login._Login')}}</van-button>
				<van-button @click="$store.commit('isRecord'),$store.commit('publicFun',['isRecordType',0])"
					type="default" size="mini"> {{$t('Login._Registro')}} </van-button>
			</div> -->
			<div class="zhtDEqmqr6aOwFvu_UTp" v-if="$store.state.config.show_jackpot">
				<div class="_VQdc8vOEOzzyOEUKmvZ"
					:style="`background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`">
					<CountTo :startVal='startVal'  @getDisplayValue="getDisplayValue" :endVal='BonusAmount' :decimals='2'
						:duration='5000' />
					<div slot="defaultValue" class="defaultValue"
						style="margin-top: .4rem;display: flex;align-items: center;--jackpot-card-count-box-scale:0.6;transform: scale(var(--jackpot-card-count-box-scale));">
						<p v-for="(item,index) in BonusTrendsAmount" style="display: flex;height: .0.83rem;font-size: .6rem;color: rgb(255, 255, 107);">
							<i v-if="item=='.'" :style="{
							  	display:'inline-block',
							  	width:'0.36rem',
							  	height: '0.83rem',
							  	backgroundImage:`url(${_coloImg})`,
							  	backgroundPosition:`-11.6rem -10.76rem`,
							  	backgroundSize: '14.52rem 14.17rem'
							  }"></i>
							<i v-else-if="item==','" :style="{
									display:'inline-block',
									width:'0.36rem',
									height: '0.83rem',
									backgroundImage:`url(${_coloImg})`,
									backgroundPosition:`-13.94rem 0rem`,
									backgroundSize: '14.52rem 14.17rem'
								}"></i>
							<i v-else :style="{
								display:'inline-block',
								width:'0.53rem',
								height: '0.83rem',
								backgroundImage:`url(${_coloImg})`,
								backgroundPosition:`${'-'+(item*0.55+2.75)}rem -12.31rem`,
								backgroundSize: '14.52rem 14.17rem'
							}"></i>
						</p>
					</div>
				
				</div>
			</div>
			<div class="conter_box" 
			 :class="{
				 isTabsShow:isTabsShow,
			 }"
			 style="padding-bottom:1rem">
				<div class="tebConTenet">
					<p @click="scrollLeftRight('left')"><svg-icon class="RbbrBFJf" icon-class="RbbrBFJf-left:all" /></p>
					<div class="tebConListConem" ref="tebScroll">
						<div class="tebConList" @click="tabFun(index)" :class="iconListIndex==index?'active':''" v-for="(item,index) in iconList">
							<img class="img" :src="item.svg" alt="" />
							{{$t('popup')[item.textName]}}
							<img class="btn_zc1_jr2" v-if="config.festival_img.button_2 != '#'" :src="config.festival_img.button_2" alt="" />
						</div>
					</div>
					<p @click="scrollLeftRight('right')"><svg-icon class="RbbrBFJf" icon-class="RbbrBFJf-right:all" /></p>
				</div>
				<div class="vwuYKuCNAmUF0GsyJhVu">
					<div class="gameItemBox" v-if="iconList[iconListIndex].name && tabNav  && tabNav[iconList[iconListIndex].name]">
						<gameItem v-for="(item_a,index_1) in tabNav[iconList[iconListIndex].name].list" :category="iconList[iconListIndex].name"
							:item="item_a" type="home" :key="index_1"></gameItem>
						<div style="display: flex;justify-content: center;width: 100%;">
							<van-empty v-if="!tabNav[iconList[iconListIndex].name].list.length" image-size="106px" class="custom-image"
								:image="img_none_sj" :description="$t('_Nenhumjogodisponvel')" />
						</div>
					</div>
				</div>
				<div class="LseXQWJMvDiV2XalL3sA">
					<div class="bUGFPYZ0IBtUg6TvqFnc vertival-box">
						<div class="UJY0E549iXw8BAops2og item-box">
							<div class="JxE2bCrlce_jVHNQ56UL link-list-title">{{ $t('_home._Cassino') }}</div>
							<div class="dIvaBEC9yHdlaEHxlYwe">
								<div @click="openUrl('event')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._Eventos') }}</div>
								<div class="m4LhLKEZzJw_JjBFp0PP link-list-item ImbZfuNlIcC1JuS98DxH">
									{{ $t('_home._Missão') }}</div>
								<div class="m4LhLKEZzJw_JjBFp0PP link-list-item ImbZfuNlIcC1JuS98DxH">
									{{ $t('_home._Rebate') }}</div>
								<div @click="openUrl('canReceive')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._Pendente') }}</div>
								<div @click="openUrl('vip')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._VIP') }}</div>
								<div @click="openUrl('promote')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._Convidar') }}</div>
								<div @click="openUrl('rechargeFund')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._FundodePrevidência') }}</div>
								<!--  -->
							</div>
						</div>
				
						<div class="UJY0E549iXw8BAops2og item-box">
							<div class="JxE2bCrlce_jVHNQ56UL link-list-title">{{ $t('_home._Jogos') }}</div>
							<div class="dIvaBEC9yHdlaEHxlYwe">
								<div @click="" class="m4LhLKEZzJw_JjBFp0PP link-list-item">{{ $t('_home._Slots') }}</div>
								<div class="m4LhLKEZzJw_JjBFp0PP link-list-item">{{ $t('_home._Pescaria') }}</div>
								<div v-if="!vuex_tokenIs" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._Demo') }}</div>
							</div>
						</div>
						<div class="UJY0E549iXw8BAops2og item-box">
							<div class="JxE2bCrlce_jVHNQ56UL link-list-title">{{ $t('_home._Suporte') }}</div>
							<div class="dIvaBEC9yHdlaEHxlYwe">
								<div @click="openUrl('notice')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._Suporteonline') }}</div>
								<div @click="openUrl('notice')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">
									{{ $t('_home._CentraldeAjuda') }}</div>
								<!-- <div @click="openUrl('notice')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">{{ $t('_home._BônusdeSugestão') }}</div> -->
							</div>
						</div>
			
					</div>
			
					<!--  -->
					<div class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box">
						<div class="ant-spin-container">
							<!-- <div class="dX6cyFScnFIBaOgvBaOs contact-us-title">{{ $t('_home._Contatenos') }}</div> -->
							<div v-if="$store.state.config.ui_type != 'mk'" class="M5NoRqtHOQuocfpNLEaP contact-us">
								<div v-if="$store.state.config.cnpj_link !='@'" class="ZRKW0CIFYaJACLzrm8Rh" @click="goToNewPage($store.state.config.cnpj_link)">
									<img src="./../../assets/kuaijiexiaz/cnpj.png"
										style="width: 0.7rem; height: 0.7rem;">
								</div>
								<div class="ZRKW0CIFYaJACLzrm8Rh" @click="goToNewPage($store.state.config.instagram)">
									<img src="./../../assets/kuaijiexiaz/1795519195972894722.png"
										style="width: 0.7rem; height: 0.7rem;">
								</div>
								<div v-if="$store.state.config.cnpj_link =='@'" class="ZRKW0CIFYaJACLzrm8Rh" @click="goToNewPage($store.state.config.facebook)">
									<img src="./../../assets/kuaijiexiaz/Facebook.png"
										style="width: 0.7rem; height: 0.7rem;">
								</div>
								<div class="ZRKW0CIFYaJACLzrm8Rh" @click="goToNewPage($store.state.config.telegram)">
									<img src="./../../assets/kuaijiexiaz/img_tg.png"
										style="width: 0.7rem; height: 0.7rem;">
								</div>
								<div class="ZRKW0CIFYaJACLzrm8Rh" @click="goToNewPage($store.state.config.whatsapp)">
									<img src="./../../assets/kuaijiexiaz/img_wa.png"
										style="width: 0.7rem; height: 0.7rem;">
								</div>
								<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAABSlBMVEUAAAD+r7DxGh38lZXzOTryXV/4gYT8qKj2cXPvKy/wQ0HxQUH4j4/zT071WVj3Z2r6mJnuNDX7jIruGhnsISf6lpf9s7b2eXnyKSj0SUr0R0j+pKTyUFHxZGj1fH36lZT6kpH1KinxIyP1OTj1amz2dHb0UFL2VVrzdHL6fnz6rKz1VlzuTEr2cnHjFxv0YmP+AAD////1AAD5///wBgf0Cg33EBH/7O/vUE3/9vj/8fP+ycn/8+7rDA//+vr+5+r+5OL7mJr6hIT2WFryNznvExPrAAH/3NzyXV//19n/wMD2QkPzLS7uKy7uJCP/1NT8iYX4fXzxZ2nzUlHzR0r/6+f+z9L9tLH9r6/8oaP2ZWnxQEH6bnL9qKTxbm7pRkj2Hx75Awn+uLn6i475eHz2dnPvWFn0JSf/+v//9+zkAADpOjbfb3rfYmx2SMi+AAAAMHRSTlMAE/4m2KFtCIrhzcRdxq2SDtAd9utAHHrmvLQssnBlTjfz8+Z/T5aOW0UzvoQ1+qzGVDgkAAAHK0lEQVRo3sWbZ1caQRRAh5UOgoJi7yWamGR47i4tNKWJgBLFgr2n/v+vWYXE8oYtMHtyLWcdOHP3TZ8dJEYYmJheHl+Yu5ThH5Qqv+TLuYXxd9N9DmIGA8N+95AkPcqYSMkhj/PjAG/tsNOdlKg6ABD0LH7kaO2b+pAvANXytuTzvhULH+17/4L0WgDqN5AcXOzjoLWNolrVihwklzPQYyH7h3RZcdTWxR7UjinXo9ZgwO2oRet01y35g0R7AJK+2W60lkVUykbN4LIbH1M+jolAexVD3jdh0OtVwuUBWJcMDY/OJFA+gGDX7w34ACg3JL9Fb+f1AOUJ+Cz6vG7gaX38mbTo8VoLT+/nKYexgHY3sgKA4uUL9PdpxgtUEXMHxtRLO+ApUHMo2FRnhUlA1cvN7FQRO0VqHlLnkWQ6T81EWCVsZp/G5ytqDkBhkN20LW5UwVzp2MCcBWoykFwhmOFPaNzgb3bhwnZ4cEHzp+BDYruEvfyB/Mwb74SLmxVUX3S/2V3ZRK28QAX64kpDLY68blm1TkqQZPmyVs3lLi6i0fvS1/Pzu3q9vqGw+4RyUa/f3p02m6XSffTi4ufP6oMgy3LHGEZDrwIusJziw37pdjd7dnRdThxsZTKNRiMejymkwi9JpZSkeDwSSWcyWweJ8vXRcXbjdHO7JjLNL0OeGALAne5kt1xMx8LdEUsfHNVzAFjssjyL/VfYW7sphnskdXAqYLNof579h/B9VY+eM1hXvpRvXSjv/XuhEMsyzK5/DXsEV4ZwHOZC6iaPQ/a2vSG8rBRvU2E+xEq4FifbYq+ACzrBR6uU92Ee96iJdl/C93T3PcyLxh7KXl5szcNWil45C/NjF7cgt4MozMhoqVBJcBQfCUg8P/vUiXFJ7xc5ihMV3K6nFe+AG4tLaY7izD4W+JSyng1S3LbiHMWRTUCGhT5CvDhZ2ohp9RIDxE+xQR4mxMlIzqLceyC2gYsa7ISM4WSN3pTayhgy34hoWQE2EhrFVXx5qF52vy+OjMyWxxJW9JOZPE6tlNXFFz+E84R+9RlDMUq8BbRG0ho/4nsAYmVjS6/4UKAIgYww1gi5HdWMvuy1FijZiD7xdQ07ZOIHHPFJUVOsANLe4Rc9E1S5ShFXxIc3LrCf0RC3F7yF4Hnim7Y6kcNiIOMURxxNa4rbaqjWtat6hyn2UBzxXkRdHAX6r4LEk2xaS7zNErsZEW9qi583K5DcPFRfNmxtA0M8iLw6xc+A0EykOo6x653EKNGoWEGp6oPOraxonpjCp2ysU3cyUQxSLlv8DxFDdQMPddp1TBnitAHxj9rdQbiLVu1hiPcaOvpxC8iXjr48BWa0H48xEqMZPRG3Z4rG0w45rMIBc+TyMYphX1PcHjBbc+P6uuokwR6r8apae3aKtyKGh9OEvoV1FYvFbubjyKMYhNK1zkVIuYYVIvGKFFFJaBW1MhefZXpZgQTJ+yBFPJTVxRc/KhtFVLUdOc5jxSjeK2qvMmO/zg1t6rIiFvcT4gNDu1Sl43xLx4w9jcAG+Kyyk+BF7JYhthOyJOHkjZiuHUxK396pyd479c1h8Xlcx+JRL2nWbjFAiKMfi0sRk/fHNqKwKDGeCHDcLSaq7CcCZDXI82kT5jiJ8p+faJ2+oF2kfMzPm6qLSDxOnniHy/q020rGLbCBV2jSSEs8M4/EtTI38VkS0IPjQEvsGEf3VGg2uutC62//KjLbdBs7Hkyl3W/Ge+86fv37Hc47OUPahFyoNKiAFsrrmlp8a4069oLboXJ8CzR/nogzrOsGqjde3sTe58fVCqEh1llI5fS4vJOJp7qZGCLpnXK2WQNGvtbngNvPM7Farmxvnt7eZI+PDpWDmMTBzlYxk0mnI4/EWzxdp9PpTHFra+fxCOZQOYO5uW1unjxIoOSqdiShMDEKtBNwJcmXD5VKJZc7OdmPRjfv70ul5te/NEvKgdN9NLq/vZ3L5aq1miBLEiiwon0M2EJeMlKg2gCLVjJtXSAhQvKSV4TQHsqcw0UYc5DXeEWVjLgBn4bJWyaBmg/4CeL9vBlmfLyHmUpSUwEKwgxh4TM7ZHGZMAlZTTUDeCyEzWrQTDO4Zkkn7GZWc35F9VNGpsVcsBM1bGaJwUlUsYyZYwab+Z+NZHstRNPcz99cQF4WgUngrBb9DqIHC+chTHYSnVj8Mr+pGYQpoh/7EPBSjy4RI8y6gYcVoH+CGMNiS0Lv3qBzgBhmynrVa2v2LJFu6JvsLei5dyHSJTP9YrdWkMZXSfc47G4JKHShHfM6SE9YRgbzBsStM7i8xz5AeiYw4hFAvxmk+XGvouWBY2l5AUCfVrS+WyUc6bNPuiTQ2lqIrs/eEOFNYMk2GJSurjpEmgxabd4AMYeBYfuyxzon5GUR/iLL8uWcVfknvvcDxFxCwytTa2ufP/Q/8mF5bW1qZdZCjPIHsqWjz6Fj+4sAAAAASUVORK5CYII="
										style="width: 0.7rem; height: 0.7rem;">
								<img src="data:image/png;base64,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"
										style="width: 0.7rem; height: 0.7rem;">
								<img src="./../../assets/kuaijiexiaz/18plus.webp"
									style="width: 0.7rem; height: 0.7rem;">
							</div>
							<div v-if="$store.state.config.ui_type == 'mk'" class="M5NoRqtHOQuocfpNLEaP contact-us">
								<div class="ZRKW0CIFYaJACLzrm8Rh" @click="goToNewPage($store.state.config.instagram)">
									<img src="./../../assets/kuaijiexiaz/group.png"
										style="height: 0.7rem;">
								</div>
								<img src="./../../assets/kuaijiexiaz/18plus.webp"
									style="width: 0.7rem; height: 0.7rem;">
							</div>
						</div>
					</div>
					<!--  -->
					<div class="company-info">
						<p v-html="$store.state.config.explain_description"></p>
					</div>
					<div v-if="$store.state.config.ui_type == 'mk'" class="company-info2" style="padding-top: .3rem;">
						
						<p><strong>{{$('_home._CASSINO')}} </strong> {{$('_home._entertainment')}}<strong>{{$('_home._NovaWave')}}</strong>, {{$('_home._Caribbeaundern')}}</p>
						<p>.{{$('_home._accessingBy')}}</p>
					</div>
					<!--  -->
					<div class="TNhhMltbvlGJmWgLd9F5 logo-area"><!-- style="padding-bottom: 0.5rem;" -->
						<img src="./../../assets/kuaijiexiaz/game_pg.png" class="goDRiiBsuEuXD3W1NphN"
							style="height: 0.38rem;">
						<img src="./../../assets/kuaijiexiaz/game_jdb.png" class="goDRiiBsuEuXD3W1NphN"
							style="height: 0.38rem;">
						<img src="./../../assets/kuaijiexiaz/game_wg.png" class="goDRiiBsuEuXD3W1NphN"
							style="height: 0.38rem;">
						<img src="./../../assets/kuaijiexiaz/game_pp.png" class="goDRiiBsuEuXD3W1NphN"
							style="height: 0.38rem;">
						<img src="./../../assets/kuaijiexiaz/game_mg.png" class="goDRiiBsuEuXD3W1NphN"
							style="width: 1rem;height: 0.38rem;">
					</div>
					<!--  -->
					<div class="ZvyDsn48oSuCoga63jmJ copy-right">
						<div class="ZvyDsn48oSuCoga63jmJ" style="padding-bottom: .1rem;    font-size: .18rem;text-align: center;">
							<ul>
								<li style="width: 50%;">
									<p class="">
									<p style="font-size: .18rem;">{{$store.state.config.project_name}}</p>
									</p>
								</li>
								<li style="width: 50%;">
									<p style="font-size: .18rem;" v-html="$store.state.config.copyright"></p>
								</li>
			
							</ul>
						</div>
					</div>
				</div>
				<!--  -->
			</div>
			
			<!-- <Overlay></Overlay> -->
			<Sidebar></Sidebar>
			
		</div>
		
	</div>


</template>

<script>
	// @ is an alias to /src
	import Sidebar from "@/components/sidebar/index.vue"
	import Swipe from "@/components/swipe/index.vue"
	import {
		ICON_NAV3Dian6,
		ICON_NAVActive
	} from "@/assets/public/icon_nav.js"
	import gameItem from "@/components/gameItem/index3.6.vue"
	import CountTo from '@/components/vue-count-to/vue-countTo.vue'
	import advertisementHome from "@/components/advertisement/home.vue"
	import sidebars from "@/components/sidebars/index.vue"
	import SanDianLiu from "@/components/header/SanDianLiu.vue"
	import {
		mapState
	} from 'vuex';
	let time;
	import Vue from 'vue'
	import {
		baseConfig,
		popAndBanner,
		notification,
		jackpot,
		getAllGameCategory,
		getDataByGameCategory
	} from "@/apis/modules/home.js"
	export default {
		name: 'Home',
		components: {
			Sidebar,
			Swipe,
			sidebars,
			CountTo,
			gameItem,
			advertisementHome,
			SanDianLiu
		},
		computed: {
			...mapState(['first_recharge','active','popList','tabNav','banner','sidebarsList','marquee','config','isCancelDisplay','vuex_token_head','userInfo','moneyInfo'])
		},
		data() {
			return {
				tongzhi: require('./../../assets/icons/images/icon_dt_pmd.png'),
				coloImgactivity: require('./../../assets/icons/images/1795312712372871170.gif'),
				startVal: 0,
				iconList: [],
				iconListIndex:0,
				stateActive:true,
				widUrl:window.location.href,
				activeList: ICON_NAVActive,
				base_Config: {},
				BonusAmount: '',
				BonusTrendsAmount: '',
				recentJson:{},
				favoriteJson:{},
				thisiTime:'',
				tabState: false,
				vuex_tokenIs: false,
				scrollDom:"",
				isTabsShow:false,
				tabForm:{
					leftRight:0,
				},
				userBalance: '0,00',
			}
		},
		created() {
			this.inviteFun();
			if (this._vuex_token && typeof this._vuex_token() == 'string') {
				this.getBalance();
				this.vuex_tokenIs = true;
				this.iconList = ICON_NAV3Dian6.filter((item, index) => {
					return item.textName != '_Demo'
				})
				this.activeList = ICON_NAVActive.filter((item, index) => {
					return index != 3
				})
			} else {
				this.iconList = ICON_NAV3Dian6
			}
			this.getpopAndBanner();
			this.getNotification();
			this.getAllGameCategory();
			this.showRegisterPage();
		},
		mounted() {
			Vue.prototype.homeScrollbarDom = this.$refs.homeScrollbar;
			this.$nextTick(() => {
			  let el=this.$refs.navTbaSwConte.$el;
			  let scrollDom=el.getElementsByClassName('van-tabs__nav--complete')[0];
			  this.scrollDom=scrollDom;
			  let offsetWidth=scrollDom.offsetWidth;
			  let scrollWidth= scrollDom.scrollWidth;
			  let scrollJisuan=scrollWidth-offsetWidth;
			  let {leftRight}=this.tabForm;
			  scrollDom.addEventListener('scroll', (e)=>{
				  if(scrollJisuan<=scrollDom.scrollLeft){
					  this.tabForm.leftRight=1
				  }else if(scrollDom.scrollLeft==0){
					  this.tabForm.leftRight=0
				  }else if(leftRight!=2 && scrollDom.scrollLeft!=0){
					  this.tabForm.leftRight=2
				  }
			  });
			});
			this.getjackpot(0);
			this.showBalance();
		},
		watch: {
			moneyInfo: {
				handler(val) {
					this.showBalance();
				},
				deep: true
			},
			active:{
				handler(val) {
					this.tabFun(val,'',true)
					// this.showBalance();
				},
				deep: true
			}
		},
		beforeDestroy() {
			clearTimeout(this.thisiTime);
		},
		methods: {
			showBalance() {
				this.userBalance = this.$store.state.config.balance_no_bonus.includes('home') ? this.moneyInfo.balance_coin_str : this.moneyInfo.balance_total_str;
			},
			scrollLeftRight(e){
				if(e=='left'){
					this.$refs.tebScroll.scrollLeft=0;
				}else if(e=='right'){
					this.$refs.tebScroll.scrollLeft=Date.now();
				}
					// this.$refs.tebScroll.scrollRight=Date.now();
			},
			CancelDisplay(e){
				this.$store.commit('publicFun',['isCancelDisplay',false])
				if(this.$store.state.isRefreshLoading){
					setTimeout(()=>{
						let isRechargeGiftTime=localStorage.getItem('isRechargeGiftTime');
						let isRechargeGift=localStorage.getItem('isRechargeGift');
						if(isRechargeGiftTime && isRechargeGift!=='false'){
							if(isRechargeGiftTime<new Date().getTime()){
								this.$store.commit('publicFun',['isCancelDisplay',true])
							}
						}
						if(!isRechargeGift&& !isRechargeGiftTime){
							if(this.first_recharge.status=='show'){
								this.$store.commit('publicFun',['isRechargeGift',true])
							}
						}
					},500)
					this.$store.commit('publicFun',['isRefreshLoading',false])
				}
			},
			showRegisterPage() {
				if(this.vuex_tokenIs || !this.$store.state.config.register_page_pop)return;
				this.$store.commit('isRecord');
				this.$store.commit('publicFun',['isRecordType',0]);
			},
			inviteFun(){
				let {id,type}=this.$route.query;
				//console.log(this.$route.query,id,type,'inviteID 22')
				if(id){
					window.localStorage.setItem('inviteID',id)
				}
				// this.$store.commit('isRecord')
				// this.$store.commit('publicFun',['isRecordType',0])
			},
			navTbaSw(e){
				if(e=='right'){
					this.scrollDom.scrollLeft=1000
				}
				if(e=='left'){
					this.scrollDom.scrollLeft=0
				}
			},
			beforeChange(name,title){//
				
			},
			scrollTabs(e) {
			},
			handleScroll(e) {
				clearTimeout(time);
				time = setTimeout(() => {
					clearTimeout(time);
					if (e.target.scrollTop > (e.target.offsetHeight/3+59)) {
						this.$store.commit('publicFun', ['Returntotop', true])
					} else if (this.$store.state.Returntotop) {
						this.$store.commit('publicFun', ['Returntotop', false])
					}
					if(e.target.scrollTop>(e.target.scrollHeight-e.target.offsetHeight-20)){
						this.isTabsShow=true
					}else{
						this.isTabsShow=false
					}
				}, 10)
			},
			isDisabled(index) {
				let isTrue = false;
				let active = this.$store.state.active;
				if (index == 3) {
					isTrue = true;
					return true;
				}
				if (active < 3) {
					if (index < 3) {
						return false;
					}
					if (index > 3) {
						isTrue = false;
						return true;
					}
				}
				if (active > 3) {
					if (index < 3) {
						isTrue = true;
						return true;
					}
					if (index > 3) {
						isTrue = false;
						return false;
					}
				}
				return isTrue;
			},
			getAllGameCategory() {
				if(this.tabNav.popular){
					return false;
				}
				getAllGameCategory({}).then(({
					code,
					data = {},
					msg
				}) => {
					this.$store.commit('publicFun', ['tabNav', data])
				})
			},
			goToNewPage(url) {
				if (url == '#') {
					return false;
				}
				window.open(url, '_blank');
			},
			congxJiazai(category,_key_) {
				let pageSize = category == 'popular' && this.$store.state.config.popular_page_size ? this.$store.state.config.popular_page_size : 6;
				let page=this.tabNav[category] ? this.tabNav[category].now/pageSize+1 : 1;
				//console.log(_key_)
				if(_key_){page=this[_key_+'Json'].now ? this[_key_+'Json'].now/pageSize+1 : 1};
				getDataByGameCategory({
					category: category,
					page: page
				}).then(({
					code,
					data = {},
					msg
				}) => {
					if(!_key_){
						this.tabNav[category] ={
							...this.tabNav[category],
							now: data.now,
							list: [...this.tabNav[category].list, ...data.list]
						}
						this.$store.commit('publicFun', ['tabNav',this.tabNav])
					}else{
						let listz=(this[_key_+'Json'].list?[...this[_key_+'Json'].list, ...data.list]:[...data.list]);
						this[_key_+'Json']={
							...this[_key_+'Json'],
							now:data.now,
							list:listz,
						}
					}
					
				})
			},
			getDisplayValue(value) {
				this.BonusTrendsAmount = value;
			},
			getpopAndBanner() { //
				if(this.banner.length){
					return false;
				}
				popAndBanner({}).then(({
					code,
					data = {},
					msg
				}) => {
					let {
						banner,
						pop,
						sidebars,
						first_recharge,
					} = data;
					this.$store.commit('publicFun', ['banner', banner])
					this.$store.commit('publicFun', ['first_recharge', first_recharge])
					// this.banner = banner;
					if (!this.popList.length) {
						this.$store.commit('popList', pop.map((item) => {
							return {
								...item,
								isShow: true,
							}
						}));
					}
					this.$store.commit('publicFun', ['sidebarsList',  sidebars.map((item) => {
						return {
							...item,
							isShow: true,
						}
					})])
				})
			},
			
			getNotification() {
				if(this.marquee){
					return false;
				}
				notification({}).then(({
					code,
					data,
					msg
				}) => { //404
					let {
						marquee
					} = data;
					this.$store.commit('publicFun', ['marquee', marquee])
				})
			},
			getjackpot(tim,_false) {
				if (!this.$store.state.config.show_jackpot)return;
				// if(_false){return false}
				clearTimeout(this.thisiTime);
				this.thisiTime = setTimeout(() => {
					
					jackpot({
						isLOgin: true,
					}).then(({
						code,
						data,
						msg
					}) => {
						this.startVal=data-1999||0
						this.BonusAmount = data || 0;
					})
					if(this.$route.name=='home'){
						this.getjackpot(10000)
					}
					let {code,category}=this.$route.query;
				}, tim)
			},
			onClickDisabled(e) {
				this.$router.push({
					name: 'subgame',
					query: {
						id: '',
						category: 'demo',
					}
				})
			},
			tabFun(e,title) {				
				this.iconListIndex=e;
				let category=this.iconList[e].name;
				console.log(category);
				if(category=='demo'){
					this.onClickDisabled()
				}
				if(category=='recent'){
					this.$router.push({
						name: 'search',
						query: {
							id: '',
							tabActive: 2,
						}
					})
				}
				if(category=='favorite'){
					this.$router.push({
						name: 'search',
						query: {
							id: '',
							tabActive: 3,
						}
					})
				}
				if(!_true){
					this.$store.commit('active', e)
				}
			},
			stickyScroLL(e) {}
		}
	}
</script>
<style scoped>
	/* // isTabsShow van-sticky van-sticky--fixed */

	.goDRiiBsuEuXD3W1NphN{
		width: 1rem;
		height: .36rem;
		border: none;
		border-radius: 0;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.tabs .imageWrap {
		margin-left: -0.1rem;
	}

	.imageWrap_s {
		margin-left: 0.05rem;
	}
	.leftButton,.rightButton {
	    background-color: rgba(0,0,0,.1);
	    border: .01rem solid hsla(0,0%,100%,.1);
	    border-radius: .18rem;
	    color: #fff;
	    cursor: pointer;
	    height: .36rem;
	    line-height: .36rem;
	    text-align: center;
	    top: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	    -webkit-transform: translateY(-50%);
	    transform: translateY(-50%);
	    width: .36rem;
		min-width: .36rem;
	}
	.leftButton svg,.rightButton svg{
		width: .15rem;
		height: .15rem;
	}
	.tabForm-box{
		width: 100%;height: 0px;display: flex;align-items: center;
		justify-content: space-between;
		position: absolute;
		top:.55rem;
		z-index: 10;
	}
	.leftButton{
		position: absolute;
		left: 0;
		transform: translateY(-50%) rotate(180deg);
	}
	.tabs  .van-tabs__content{
		position: relative;
	}
	.rightButton{
		position: absolute;
		right: 0;
	}
	.warp-wYU5EComes{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0.2rem 0;
	}
	.warp-card-user-login-wrap-vip-BttMM {
	    font-size: .16rem;
	    height: .24rem;
	    padding: 0 .06rem;
	    line-height: .24rem;
	    background-color: rgb(36, 178, 153);
	    color: #e5b952;
	    margin-right: .08rem;
	    border-radius: .04rem;
	    white-space: nowrap
	}
	.me-infoname{
		display: flex;
		align-items: center;
	}
	.me-infoname i {
	    font-size: .22rem;
	    font-style: normal;
	    color: var(--theme-text-color);
	    margin-right: .04rem;
	    overflow: hidden
	}
	.me-infoname .imageWrap{
		width: .32rem;
		height: .32rem;
		color: var(--theme-alt-primary);
	}
	.countTextBox {
	    display: flex;
	    align-items: center;
	    padding: .04rem .08rem .04rem .03rem;
	    width: -moz-fit-content;
	    width: fit-content;
		display: flex;
	    border-radius: 1.8rem;
		margin-top: .1rem;
	    opacity: 1;
	    border: .02rem solid var(--theme-color-line);
	}
	.countTextBox .notranslate{
			color: var(--theme-secondary-color-finance);
		    font-size: .24rem;
		    text-overflow: ellipsis;
		    white-space: nowrap;
			    padding: 0 .08rem;
		    overflow: hidden;
		    text-decoration: underline
	}
	.countTextBox .xuanzhuan{
		width: .25rem !important;
		height: .25rem !important;
		color: var(--theme-alt-primary);
	}
	.SaqueDepósito{
		display: flex;
		align-items: center;
	}
	.SaqueDepósito .xuanzhuan{
		margin: 0 auto;
		width: 0.48rem !important; height: 0.48rem !important; color: var(--theme-text-color-darken);
	}
	.SaqueDepósito div{
		width: 1rem;
		display: flex;align-items: center;
		flex-wrap: wrap;
	}
	.SaqueDepósito  p{
		color: var(--theme-text-color-darken);
		    line-height: 1;
			width: 100%;
			text-align: center;
		    padding-top: .08rem;
		    font-size: .16rem
	}
	.warp-notlogin-azGf5 {
	    width: 100%;
	    display: flex;
	    justify-content: space-between;
	    gap: .16rem;
	    overflow: hidden
	}
	
	.warp-notlogin-azGf5>div {
	    width: 44.5%;
	    height: .7rem;
	    flex-shrink: 0;
	    position: relative;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    color: var(--theme-primary-font-color);
	    font-size: .3rem
	}
	
	.warp-notlogin-azGf5>div:first-child {
	    background-color: var(--theme-primary-color);
	    border-top-left-radius: .1rem;
	    border-bottom-left-radius: .1rem
	}
	
	.warp-notlogin-azGf5>div:first-child>span {
	    margin-left: .6rem
	}
	
	.warp-notlogin-azGf5>div:first-child:after {
	    position: absolute;
	    width: 0;
	    height: 0;
	    display: inline-block;
	    content: " ";
	    border-top: .8rem solid var(--theme-primary-color);
	    border-left: 0 solid transparent;
	    border-right: .8rem solid transparent;
	    border-bottom: 0 solid transparent;
	    right: -.68rem;
	    top: 0
	}
	
	.warp-notlogin-azGf5>div:last-child {
	    background-color: var(--theme-scroll-bar-bg-color);
					  /* border: 0.01rem solid var(--theme-primary-color); */
					  color: var(--theme-disabled-font-color);
					  box-sizing: border-box;
					  border-left: none;
	    border-top-right-radius: .1rem;
	    border-bottom-right-radius: .1rem;
					     /* background-color: var(--theme-disabled-bg-color);
					      border-color: var(--theme-disabled-bg-color);
					      color: var(--theme-disabled-font-color); */
	}
	
	.warp-notlogin-azGf5>div:last-child>span {
	    margin-right: .6rem
	}
	
	.warp-notlogin-azGf5>div:last-child:after {
	    position: absolute;
	    width: 0;
	    height: 0;
	    display: inline-block;
	    content: " ";
	    border-top: 0 solid transparent;
	    border-left: .8rem solid transparent;
					  box-sizing: border-box;
	    border-right: 0 solid transparent;
	    border-bottom: .8rem solid var(--theme-scroll-bar-bg-color);
					  /* border: 1px solid var(--theme-primary-color); */
	    left: -.68rem;
	    bottom: 0
	}
	.tebConTenet{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--theme-home-bg);
		font-size: .26rem;
		padding: .48rem 0;
		color: var(--theme-alt-neutral-2);
		margin-bottom: .2rem;
		position:sticky;
		top: -0.01rem;
		z-index: 20;
	}
	.tebConTenet .btn_zc1_jr2{
		width: .5rem;
		height: .5rem;
		display: none;
		position: absolute;
		bottom: 0;
		right: 0;
	}
	.game-tabItem-name-bQ3zy {
	    color: var(--theme-alt-neutral-2);
	    max-width: 96%;
	    line-height: .28rem;
	    font-size: .26rem;
	    overflow: hidden;
	    text-align: center;
	    text-overflow: ellipsis;
	    white-space: nowrap;
	    margin-top: .06rem
	}
	.tebConList{
		width: 1.36rem;
		min-width: 1.36rem;
		box-sizing: border-box;
		position: relative;
		min-height:1.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
	}
	.tebConListConem{
		display: flex;
		align-items: center;
		width: 74%;
		scroll-behavior: smooth;
		overflow: scroll;
	}
	.RbbrBFJf{
		width: .8rem !important;
		height: .8rem !important;
	}
	.tebConList .img{
		width: .84rem;
		height: .84rem;
	}
	.tebConList.active{
		background: var(--theme-primary-color);
		border-radius: .16rem;
		padding-top: .1rem;
		color: var(--theme-primary-font-color);
	}
	.tebConList.active .btn_zc1_jr2{
		display: block;
	}
</style>

<style>
	.me3Dian6 .menPensmeConems .swiper-box {
		padding:.16rem .2rem .16rem;
	}
	.me3Dian6  #icon-sprite_icon_dt_1pmd--svgSprite2{
		opacity: 0;
		animation: fadeInOut .5s infinite 0.1s;
	}
	.me3Dian6  #icon-sprite_icon_dt_1pmd--svgSprite3{
		opacity: 0;
		animation: fadeInOut .5s infinite 0.2s;
	}
	.me3Dian6  @keyframes fadeInOut {
		0% {
			opacity: 0; /*初始状态 透明度为0*/
		}
		100% {
			opacity: 1; /*结尾状态 透明度为1*/
		}
	}
	.me3Dian6  .isTabsShow .van-sticky{
		opacity: 0;
	}
	.me3Dian6  .van-sticky.van-sticky--fixed {
		transform: initial;
		transition: .5s;
	}

	.me3Dian6  .conter_box .van-tab--disabled {
		color: #646566 !important;
		cursor:pointer;
	}
	.me3Dian6 {
		.conter_box .van-tab{
				padding: 0 !important;
			}
			
			.home-scrollbar .van-tab__text--ellipsis {
				-webkit-line-clamp: initial;
			}
		
			.home-scrollbar .van-sticky--fixed {
				z-index: 88;
			}
		
			.home-scrollbar {
				height: 100vh;
				/* overflow: scroll; */
			}
			.conterTeng-scrollbar{
				overflow: scroll;
			}
		
		
			.conterTeng-scrollbar::-webkit-scrollbar {
			    width: .06rem;
				height: 1rem;
				display: block;
				position: relative;
			}
			 
			/* 自定义滚动条轨道 */
			.conterTeng-scrollbar::-webkit-scrollbar-track {
			  background:transparent; /* 设置轨道的背景颜色 */
			}
			 
			/* 自定义滚动条的滑块（thumb） */
			.conterTeng-scrollbar::-webkit-scrollbar-thumb {
			  background: var(--theme-color-line); /* 设置滑块的背景颜色 */
			  
			}
			 
			/* 当滑块悬停或活动时自定义滚动条的滑块 */
			.conterTeng-scrollbar::-webkit-scrollbar-thumb:hover {
			  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
			}
			.conterTeng-scrollbar {
			-ms-overflow-style:scroll; /* 针对IE、Edge浏览器 */
			scrollbar-width: none;  /*针对Firefox浏览器 */
			}
		
			.marquee {
				background-color: transparent;
				border-radius: 0;
				/* -webkit-box-shadow: 0 .03rem .09rem 0 transparent; */
				/* box-shadow: 0 .03rem .09rem 0 transparent; */
				font-size: .24rem !important;
				padding: 0 .2rem 0 .25rem;
				-ms-flex-align: center;
				-ms-flex-pack: justify;
				align-items: center;
				justify-content: center;
				background-color: transparent !important;
				border-radius: .1rem;
				/* -webkit-box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06); */
				/* box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06); */
				color: var(--theme-text-color) !important;
				display: -ms-flexbox;
				display: flex;
				justify-content: space-between;
				width: 100%;
				padding: 0 !important;
			}
		
			.van-hairline--bottom::after {
				border: none !important;
			}
		
			.marquee .van-icon {
				display: flex;
				justify-content: center;
				align-content: center;
				margin-right: 5px;
			}
			.notice-barCome{
				padding: .06rem .2rem !important;
				box-sizing: border-box;
			}
			.notice-bar {
				display: flex;
				width: 100%;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				box-shadow: 0 0 .1rem 0 var(--theme-primary-color)!important;
				    border-radius: .1rem;
				    padding: 0 .04rem;
				 cursor: pointer;
			}
			.notice-bar .van-icon{
				display: none;
				margin-right: .2rem;
			}
		
			.zhtDEqmqr6aOwFvu_UTp {
				margin: 0 .2rem;
				align-items: center;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-direction: column;
				flex-direction: column;
				justify-content: center;
			}
		
			._VQdc8vOEOzzyOEUKmvZ {
				cursor: pointer;
				height: var(--jackpot-card-height);
				margin: var(--jackpot-card-margin);
				position: relative;
				width: var(--jackpot-card-width);
				display: flex;
				align-items: center;
				justify-content: center;
			}
		
			.defaultValue {
				justify-content: center;
			}
		
			.tabs {
				height: 100%;
			}
		
			.vwuYKuCNAmUF0GsyJhVu {
				padding: 0 0.2rem;
			}
		
			.gameItemBox {
				display: flex;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				height: 100%;
			}
		
			.scroll-container {
				height: 100%;
				overflow: auto;
			}
		
			.tabs .van-tab {
				line-height: normal;
			}
		
			.tabs .van-tabs--line .van-tabs__wrap {
				height: auto !important;
			}
		
			.tabs .van-tabs .van-tabs__nav {
				background-color: var(--cms-background-color-primary);
				border-bottom: .01rem solid var(--theme-color-line);
				height: 1.06rem;
				padding: .08rem 0 0;
			}
			
		
			.tabs .van-tabs__line {
				background-color: var(--cms-primary-color);
				border-radius: .04rem .04rem 0 0;
				height: .04rem;
				min-width: 1.5rem;
				bottom: 0;
			}
		
			.tabs .van-tab--active .h5MidMenuTab {
				color: var(--cms-primary-color) !important;
			}
		
			.tabs .cover {
				background: transparent !important;
			}
		
			.tabs .imageWrap {
				height: .46rem !important;
				width: .6rem !important;
			}
		
			.h5MidMenuTab {
				min-width: 1.5rem;
				position: relative;
				text-align: center;
				z-index: 2;
				color: var(--cms-text-color-secondary);
			}
			
			.h5MidMenuTab-conter{
				color: var(--cms-primary-color);
			}
		
			.game-category-name {
				line-height: 1.5;
				max-width: 1.36rem;
				width: 1.36rem !important;
			}
		
			.leftTitle {
				-ms-flex-align: center;
				align-items: center;
				color: var(--cms-text-color-primary);
				display: -ms-flexbox;
				display: flex;
				font-size: .3rem;
			}
		
			.kQtvRRirB33JTKwlSb26 {
				-ms-flex-align: center;
				-ms-flex-pack: justify;
				align-items: center;
				display: -ms-flexbox;
				display: flex;
				justify-content: space-between;
				padding: .3rem 0;
			}
		
			.bkAYznjEc9hUqGQh_a3S {
				display: block;
				font-size: .24rem;
				text-align: center;
				color: var(--cms-text-color-secondary);
				margin-top: .1rem;
			}
		
			.WGAruokZzpTWkHI2SQ9G {
				color: var(--cms-global-spare-color);
				display: block;
				font-size: .24rem;
				margin-top: .03rem;
			}
		
			.LseXQWJMvDiV2XalL3sA {
				padding: .4rem .2rem;
				position: relative;
				width: 100%;
		    /* background-color: var(--theme-home-bg); */
				z-index: 1;
				box-sizing: border-box;
				padding-bottom: 0.5rem;
			}
		
			.UJY0E549iXw8BAops2og {
				-ms-flex: 1;
				flex: 1;
				overflow: hidden
			}
		
			.vertival-box {
				margin-bottom: .4rem;
				padding-bottom: .4rem;
				/* position: relative */
			}
		
			.vertival-box>div {
				padding-right: .2rem
			}
		
			.UJY0E549iXw8BAops2og .JxE2bCrlce_jVHNQ56UL {
				color: var(--theme-text-color-lighten);
				font-size: .18rem;
				margin-bottom: .12rem
			}
		
			.TxOZ1v6RrtK6SNKSEukb .vertival-box {
				margin-bottom: .4rem;
				padding-bottom: .48rem;
				position: relative
			}
		
			.bUGFPYZ0IBtUg6TvqFnc {
				display: -ms-flexbox;
				display: flex;
			}
		
			.link-list-title {
				color: var(--theme-text-color);
		
				margin-bottom: .2rem
			}
		
			.vertival-box:after {
				background-color: var(--theme-colorxxx-line);
				bottom: 0;
				content: "";
				height: .01rem;
				left: 50%;
				position: absolute;
				-webkit-transform: translateX(-50%);
				transform: translateX(-50%);
				width: 100%;
			}
		
			.UJY0E549iXw8BAops2og .dIvaBEC9yHdlaEHxlYwe .m4LhLKEZzJw_JjBFp0PP {
				color: var(--theme-text-color);
				cursor: pointer;
				font-size: .24rem !important;
				margin-bottom: .1rem;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap
			}
		
			.company-info {
				padding-bottom: .4rem;
				position: relative;
				    text-align: center;
			}
		
			.contactus-box {
				padding-bottom: .4rem;
				margin-bottom: .4rem;
		    	border-bottom: .02rem solid var(--theme-color-line);
			}
		
			.dX6cyFScnFIBaOgvBaOs {
				color: var(--cms-text-color-secondary);
				font-size: .24rem;
				font-weight: 400;
				margin-bottom: .2rem
			}
		
			.ZRKW0CIFYaJACLzrm8Rh {
				box-sizing: border-box;
				height: .7rem;
				display: flex;
			}
		
			.M5NoRqtHOQuocfpNLEaP {
				-ms-flex-align: center;
				align-items: center;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				box-sizing: border-box;
				gap: .2rem;
				max-width: fit-content;
				margin-left: auto;
				margin-right: auto;
			}
		
			.company-info:after {
				background-color: var(--theme-color-line);
				bottom: 0;
				content: "";
				height: .015rem;
				left: 50%;
				position: absolute;
				-webkit-transform: translateX(-50%);
				transform: translateX(-50%);
				width: 100%
			}
		
			.company-info {
				color: var(--theme-text-color-lighten);
				font-size: .2rem;
				line-height: 1.66;
				word-break: break-all
			}

			.company-info2 {
				width: 6.7rem;
    			margin: .2rem auto 0;
				position: relative;
				text-align: center;
				color: var(--theme-text-color-lighten);
				font-size: .22rem;
				line-height: 1.66;
			}
		
			.TNhhMltbvlGJmWgLd9F5 {
				-ms-flex-pack: center;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				gap: .1rem;
				justify-content: center;
				margin-top: .4rem
			}
		
			.copy-right {
				padding-top: .4rem
			}
		
			/* .ZvyDsn48oSuCoga63jmJ ul {
		    -ms-flex-align: center;
		    align-items: center;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    width: 100%
		} */
			.ZvyDsn48oSuCoga63jmJ {
				-ms-flex-pack: center;
				display: -ms-flexbox;
				display: flex;
				justify-content: center;
				width: 100%
			}
		
			.ZvyDsn48oSuCoga63jmJ ul {
				-ms-flex-pack: center;
				display: -ms-flexbox;
				display: flex;
				justify-content: center;
				margin: 0 !important;
				width: 100%
			}
		
			.ZvyDsn48oSuCoga63jmJ ul li {
				border-right: .025rem solid var(--theme-color-line);
				color: var(--theme-text-color-lighten);
				font-size: .16rem;
				line-height: 1.2;
				overflow: hidden;
				padding: 0 .32rem;
				text-overflow: ellipsis;
				white-space: nowrap
			}
		
			.ZvyDsn48oSuCoga63jmJ ul li:last-child {
				border-right: 0
			}
			.svg-icon_pmd{
				position: absolute;
				left: 0;
			}
			.N4LsWhJBhqqyTkv6V0NE {}
			
			
	}
	
</style>
